<template>
  <div class="about-section" style="margin-bottom: 5rem;">
    <div class="about-top">
      <div id="carouselExampleCaptions" class="carousel slide">

        <div class="carousel-inner">
          <div class="w-100 h-100 position-relative">

            <img src="https://artive.com.bd/media/images/WEB_Contact.webp " class="d-md-block d-none w-100 " alt="..."
                 style="object-fit: cover;">
            <img src="https://artive.com.bd/media/images/MOB_Contact.webp" class="d-block d-md-none w-100 h-100"
                 alt="..." style="">
            <div class="carousel-caption carousel_caption_one ">
              <h1 class="about-top-head">Connect with Artive
                For a<br> Solution That Fits Your Needs!</h1>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="contact_mid">
      <div class="contact_mid_form" style="margin-bottom: 3.75rem;">
        <div class="contact_mid_head">
          <h3 class="">GET CONNECTED WITH US</h3>
          <p>We're here to help with your audio-visual and smart technology needs. For product info, support,
            or
            customization, contact us today!</p>
        </div>
        <div class="contact_form">

          <form @submit.prevent="submitForm" class="d-md-flex form" style="gap: 5rem; padding: 50px;">
            <div class="w-md-50 w-100">
              <div class="contact_details d-flex flex-column " style="gap: 30px">
                <div class="contact_item d-flex align-items-start gap-4">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                       fill="none">
                    <path
                        d="M20.0002 10.999H22.0002C22.0002 5.869 18.1272 2 12.9902 2V4C17.0522 4 20.0002 6.943 20.0002 10.999Z"
                        fill="#0095DE"/>
                    <path
                        d="M13.0003 8.00024C15.1033 8.00024 16.0003 8.89724 16.0003 11.0002H18.0003C18.0003 7.77524 16.2253 6.00024 13.0003 6.00024V8.00024ZM16.4223 13.4432C16.2301 13.2686 15.9776 13.1754 15.7181 13.1835C15.4585 13.1915 15.2123 13.3001 15.0313 13.4862L12.6383 15.9472C12.0623 15.8372 10.9043 15.4762 9.71228 14.2872C8.52028 13.0942 8.15928 11.9332 8.05228 11.3612L10.5113 8.96724C10.6977 8.78637 10.8064 8.54006 10.8144 8.28045C10.8225 8.02083 10.7292 7.76828 10.5543 7.57624L6.85928 3.51324C6.68432 3.3206 6.44116 3.20374 6.18143 3.1875C5.92171 3.17125 5.66588 3.2569 5.46828 3.42624L3.29828 5.28724C3.12539 5.46075 3.0222 5.69169 3.00828 5.93624C2.99328 6.18624 2.70728 12.1082 7.29928 16.7022C11.3053 20.7072 16.3233 21.0002 17.7053 21.0002C17.9073 21.0002 18.0313 20.9942 18.0643 20.9922C18.3088 20.9786 18.5396 20.8749 18.7123 20.7012L20.5723 18.5302C20.7417 18.3328 20.8276 18.077 20.8115 17.8173C20.7954 17.5576 20.6788 17.3143 20.4863 17.1392L16.4223 13.4432Z"
                        fill="#0095DE"/>
                  </svg>
                  <div class="contact_number_email d-flex flex-column align-items-center gap-2">
                    <h5>{{ siteData.phone_number }}</h5>
                    <h5>{{ siteData.phone_number_2 }}</h5>
                  </div>
                </div>
                <div class="contact_item d-flex align-items-start gap-4">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                       fill="none">
                    <path d="M22 4H2V20H22V4ZM20 8L12 13L4 8V6L12 11L20 6V8Z" fill="#0095DE"/>
                  </svg>
                  <div class="contact_number_email d-flex flex-column align-items-center gap-2">
                    <h5>{{ siteData.email }}</h5>
                    <h5>{{ siteData.email_2 }}</h5>
                  </div>
                </div>
                <div class="contact_item d-flex align-items-start gap-4">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                       fill="none">
                    <path
                        d="M12 1.5C9.81276 1.50258 7.71584 2.3726 6.16923 3.91922C4.62261 5.46584 3.75259 7.56276 3.75001 9.75C3.74739 11.5374 4.33124 13.2763 5.41201 14.7C5.41201 14.7 5.63701 14.9963 5.67376 15.039L12 22.5L18.3293 15.0353C18.3623 14.9955 18.588 14.7 18.588 14.7L18.5888 14.6978C19.669 13.2747 20.2526 11.5366 20.25 9.75C20.2474 7.56276 19.3774 5.46584 17.8308 3.91922C16.2842 2.3726 14.1873 1.50258 12 1.5ZM12 12.75C11.4067 12.75 10.8266 12.5741 10.3333 12.2444C9.83995 11.9148 9.45543 11.4462 9.22837 10.8981C9.00131 10.3499 8.9419 9.74667 9.05765 9.16473C9.17341 8.58279 9.45913 8.04824 9.87869 7.62868C10.2982 7.20912 10.8328 6.9234 11.4147 6.80764C11.9967 6.69189 12.5999 6.7513 13.1481 6.97836C13.6962 7.20542 14.1648 7.58994 14.4944 8.08329C14.8241 8.57664 15 9.15666 15 9.75C14.999 10.5453 14.6826 11.3078 14.1202 11.8702C13.5578 12.4326 12.7954 12.749 12 12.75Z"
                        fill="#0095DE"/>
                  </svg>
                  <div class="contact_number_email d-flex flex-column gap-2">
                    <div class="contact_location">
                      <h3>Corporate Office</h3>
                      <p class="text-wrap">{{ siteData.office_address }}</p>
                    </div>
                    <div class=" contact_location">
                      <h3>Sales Center</h3>
                      <p class="text-wrap">{{ siteData.sales_address }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="social_icon d-flex " style="gap: 24px">
                <a :href="siteData.facebook_url">
                  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30"
                       fill="none">
                    <circle cx="15" cy="15" r="14.5" stroke="#4A4A4A"/>
                    <path
                        d="M15.2191 15.6139V21.5H13.649V15.6139V15.1139H13.149H11.5V13.6252H13.149H13.649V13.1252V11.2898C13.649 10.3282 13.9403 9.64471 14.3885 9.20176C14.8382 8.75729 15.5015 8.5 16.35 8.5C16.9108 8.5 17.4196 8.5264 17.7704 8.5527V9.82422L16.9526 9.82459C16.9525 9.82459 16.9524 9.82459 16.9524 9.82459C16.3692 9.82462 15.882 9.96261 15.5659 10.3381C15.2659 10.6944 15.2191 11.1545 15.2191 11.5362V13.1252V13.6252H15.7191H17.615L17.4231 15.1139H15.7191H15.2191V15.6139Z"
                        fill="#4A4A4A" stroke="#4A4A4A"/>
                  </svg>
                </a>
                <a :href="siteData.x_url">
                  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
                    <path
                        d="M30 15C30 23.2843 23.2843 30 15 30C6.71573 30 0 23.2843 0 15C0 6.71573 6.71573 0 15 0C23.2843 0 30 6.71573 30 15ZM1.00038 15C1.00038 22.7318 7.26822 28.9996 15 28.9996C22.7318 28.9996 28.9996 22.7318 28.9996 15C28.9996 7.26822 22.7318 1.00038 15 1.00038C7.26822 1.00038 1.00038 7.26822 1.00038 15Z"
                        fill="#4A4A4A"/>
                    <path
                        d="M19.3845 10.003H10.6155C8.895 10.003 7.5 11.383 7.5 13.084V17.419C7.5 19.1215 8.895 20.5 10.6155 20.5H19.3845C21.105 20.5 22.5 19.12 22.5 17.419V13.084C22.5 11.3815 21.105 10.003 19.3845 10.003ZM17.2785 15.463L13.176 17.398C13.1509 17.4099 13.1232 17.4152 13.0955 17.4135C13.0678 17.4118 13.041 17.4032 13.0175 17.3884C12.994 17.3736 12.9746 17.3531 12.9612 17.3288C12.9477 17.3045 12.9406 17.2773 12.9405 17.2495V13.2595C12.9408 13.2314 12.9482 13.2038 12.9621 13.1794C12.976 13.1549 12.9959 13.1344 13.02 13.1199C13.044 13.1053 13.0714 13.0971 13.0995 13.0961C13.1276 13.095 13.1555 13.1012 13.1805 13.114L17.2815 15.169C17.3085 15.1831 17.331 15.2044 17.3466 15.2305C17.3623 15.2566 17.3704 15.2865 17.3701 15.3169C17.3698 15.3473 17.361 15.3771 17.3449 15.4029C17.3287 15.4287 17.3057 15.4495 17.2785 15.463Z"
                        fill="#4A4A4A"/>
                  </svg>
                </a>
                <a :href="siteData.linkedin_url">
                  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30"
                       fill="none">
                    <circle cx="15" cy="15" r="14.5" stroke="#1E1E1E"/>
                    <mask id="path-2-inside-1_264_347" fill="white">
                      <path
                          d="M21.9965 22L22 21.9994V16.8649C22 14.3531 21.4592 12.4182 18.5227 12.4182C17.1111 12.4182 16.1637 13.1928 15.777 13.9272H15.7362V12.6527H12.9519V21.9994H15.8511V17.3713C15.8511 16.1527 16.0821 14.9743 17.5912 14.9743C19.0781 14.9743 19.1002 16.365 19.1002 17.4494V22H21.9965ZM8.231 12.6533H11.1337V22H8.231V12.6533ZM9.68117 8C8.75308 8 8 8.75308 8 9.68117C8 10.6092 8.75308 11.3781 9.68117 11.3781C10.6092 11.3781 11.3623 10.6092 11.3623 9.68117C11.362 9.23539 11.1848 8.80796 10.8696 8.49274C10.5544 8.17753 10.1269 8.00031 9.68117 8Z"/>
                    </mask>
                    <path
                        d="M21.9965 22L22 21.9994V16.8649C22 14.3531 21.4592 12.4182 18.5227 12.4182C17.1111 12.4182 16.1637 13.1928 15.777 13.9272H15.7362V12.6527H12.9519V21.9994H15.8511V17.3713C15.8511 16.1527 16.0821 14.9743 17.5912 14.9743C19.0781 14.9743 19.1002 16.365 19.1002 17.4494V22H21.9965ZM8.231 12.6533H11.1337V22H8.231V12.6533ZM9.68117 8C8.75308 8 8 8.75308 8 9.68117C8 10.6092 8.75308 11.3781 9.68117 11.3781C10.6092 11.3781 11.3623 10.6092 11.3623 9.68117C11.362 9.23539 11.1848 8.80796 10.8696 8.49274C10.5544 8.17753 10.1269 8.00031 9.68117 8Z"
                        fill="#1E1E1E"/>
                    <path
                        d="M21.9965 22V27.3333H22.4376L22.8728 27.2609L21.9965 22ZM22 21.9994L22.8763 27.2603L27.3333 26.5179V21.9994H22ZM15.777 13.9272V19.2606H18.9961L20.496 16.4123L15.777 13.9272ZM15.7362 13.9272H10.4028V19.2606H15.7362V13.9272ZM15.7362 12.6527H21.0695V7.31933H15.7362V12.6527ZM12.9519 12.6527V7.31933H7.61858V12.6527H12.9519ZM12.9519 21.9994H7.61858V27.3328H12.9519V21.9994ZM15.8511 21.9994V27.3328H21.1844V21.9994H15.8511ZM19.1002 22H13.7669V27.3333H19.1002V22ZM8.231 12.6533V7.31992H2.89767V12.6533H8.231ZM11.1337 12.6533H16.467V7.31992H11.1337V12.6533ZM11.1337 22V27.3333H16.467V22H11.1337ZM8.231 22H2.89767V27.3333H8.231V22ZM9.68117 8L9.68486 2.66667H9.68117V8ZM11.3623 9.68117H16.6957L16.6957 9.67747L11.3623 9.68117ZM22.8728 27.2609L22.8763 27.2603L21.1237 16.7386L21.1202 16.7391L22.8728 27.2609ZM27.3333 21.9994V16.8649H16.6667V21.9994H27.3333ZM27.3333 16.8649C27.3333 15.4927 27.245 13.0325 25.8758 10.858C24.1507 8.11808 21.3077 7.08483 18.5227 7.08483V17.7515C18.6896 17.7515 18.4445 17.7809 18.0131 17.5755C17.5233 17.3425 17.112 16.9585 16.8493 16.5412C16.6262 16.1869 16.603 15.9576 16.6212 16.0585C16.6392 16.1582 16.6667 16.4005 16.6667 16.8649H27.3333ZM18.5227 7.08483C15.0426 7.08483 12.3251 9.03606 11.058 11.4422L20.496 16.4123C20.0024 17.3496 19.1796 17.7515 18.5227 17.7515V7.08483ZM15.777 8.59392H15.7362V19.2606H15.777V8.59392ZM21.0695 13.9272V12.6527H10.4028V13.9272H21.0695ZM15.7362 7.31933H12.9519V17.986H15.7362V7.31933ZM7.61858 12.6527V21.9994H18.2852V12.6527H7.61858ZM12.9519 27.3328H15.8511V16.6661H12.9519V27.3328ZM21.1844 21.9994V17.3713H10.5177V21.9994H21.1844ZM21.1844 17.3713C21.1844 17.2119 21.1939 17.2209 21.1767 17.3279C21.161 17.4256 21.0929 17.8062 20.8258 18.2908C20.5278 18.8313 20.0198 19.426 19.2663 19.8432C18.5437 20.2434 17.9072 20.3077 17.5912 20.3077V9.641C16.5206 9.641 15.2893 9.85258 14.0989 10.5118C12.8778 11.188 12.029 12.1535 11.4847 13.1409C10.5343 14.8647 10.5177 16.6644 10.5177 17.3713H21.1844ZM17.5912 20.3077C17.1116 20.3077 16.2652 20.1844 15.4028 19.5827C14.5518 18.989 14.1315 18.2407 13.9448 17.7693C13.8545 17.5414 13.8105 17.3605 13.7892 17.2562C13.7677 17.1508 13.762 17.0865 13.7614 17.0805C13.7608 17.0736 13.763 17.0962 13.7647 17.1637C13.7664 17.2338 13.7669 17.3167 13.7669 17.4494H24.4336C24.4336 17.1396 24.4964 15.4432 23.8618 13.8411C23.4837 12.8865 22.7791 11.7228 21.5057 10.8344C20.2209 9.93815 18.8142 9.641 17.5912 9.641V20.3077ZM13.7669 17.4494V22H24.4336V17.4494H13.7669ZM19.1002 27.3333H21.9965V16.6667H19.1002V27.3333ZM8.231 17.9866H11.1337V7.31992H8.231V17.9866ZM5.80033 12.6533V22H16.467V12.6533H5.80033ZM11.1337 16.6667H8.231V27.3333H11.1337V16.6667ZM13.5643 22V12.6533H2.89767V22H13.5643ZM9.68117 2.66667C5.80756 2.66667 2.66667 5.80756 2.66667 9.68117H13.3333C13.3333 11.6986 11.6986 13.3333 9.68117 13.3333V2.66667ZM2.66667 9.68117C2.66667 13.4899 5.74312 16.7114 9.68117 16.7114V6.04475C11.763 6.04475 13.3333 7.72859 13.3333 9.68117H2.66667ZM9.68117 16.7114C13.6192 16.7114 16.6957 13.4899 16.6957 9.68117H6.029C6.029 7.72859 7.59929 6.04475 9.68117 6.04475V16.7114ZM16.6957 9.67747C16.6944 7.81849 15.9553 6.03601 14.6408 4.72151L7.09835 12.264C6.41428 11.5799 6.02967 10.6523 6.029 9.68486L16.6957 9.67747ZM14.6408 4.72151C13.3263 3.40701 11.5438 2.66796 9.68486 2.66667L9.67747 13.3333C8.71004 13.3327 7.78243 12.9481 7.09835 12.264L14.6408 4.72151Z"
                        fill="#1E1E1E" mask="url(#path-2-inside-1_264_347)"/>
                  </svg>
                </a>
              </div>
              <div class="map">
<!--                <iframe-->
<!--                    src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d29179.217218199577!2d90.42329600000001!3d23.9108096!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sbd!4v1724653791908!5m2!1sen!2sbd"-->
<!--                    width="100%" height="100%" style="border:0; border-radius: 20px;" allowfullscreen=""-->
<!--                    loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>-->
                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3651.919353537266!2d90.3919346104015!3d23.750255108643948!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3755b8bd25e4e1fd%3A0xeae5ca6e7c8406a!2sNetBiz%20Technologies!5e0!3m2!1sbn!2sbd!4v1730400240771!5m2!1sbn!2sbd"
                    width="100%" height="100%" style="border:0; border-radius: 20px;" allowfullscreen="" loading="lazy"
                    referrerpolicy="no-referrer-when-downgrade"></iframe>
              </div>
            </div>
            <h4 class="text-center mt-3 d-md-none d-block">Reach Us</h4>
            <div class="w-md-50 w-100 form_field">
              <div class="contact_here">
                <input type="text" v-model="formData.first_name" placeholder="First Name">
              </div>
              <div class="contact_here">
                <input type="email" v-model="formData.email" placeholder="Email">
              </div>
              <div class="contact_here">
                <input type="text" v-model="formData.phone" placeholder="Phone" max="15" min="10">
              </div>
              <div class="contact_here">
                <input type="text" v-model="formData.address" placeholder="Company Name / Address">
              </div>
              <div class="d-flex align-items-center justify-content-between radios" style="gap: 2.25rem;">
                <div class="form-check d-flex align-items-center patient_check w-md-50 w-100" style="gap: 2.25rem;">
                  <input class="m-0 form-check-input" type="radio" v-model="formData.types" value="Product">
                  <label class="form-check-label">
                    Product
                  </label>
                </div>
                <div class="form-check d-flex align-items-center patient_check w-md-50 w-100" style="gap: 36px">
                  <input class="m-0 form-check-input" type="radio" v-model="formData.types" value="Solution">
                  <label class="form-check-label">
                    Solution
                  </label>
                </div>
              </div>
              <div class="contact_here">
                <textarea v-model="formData.description" placeholder="Write here...."></textarea>
              </div>
              <input class="contact_sub" type="submit" value="SUBMIT">
            </div>
          </form>
        </div>
      </div>
      <div class="contact_mid_faq">
        <div>
          <h3 class="faq_header">Frequently Asked Question</h3>
        </div>
        <div>
          <div class="faq">
            <div class="faq_container">
              <div class="accordion d-flex flex-column" style="gap: 40px"
                   id="accordionPanelsStayOpenExample">
                <div class="accordion-item faq_item">
                  <h2 class="accordion-header">
                    <button class="accordion-button faq_accordion" type="button"
                            data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseOne"
                            aria-expanded="true" aria-controls="panelsStayOpen-collapseOne">
                      What is Artive?
                    </button>
                  </h2>
                  <div id="panelsStayOpen-collapseOne" class="accordion-collapse collapse show">
                    <div class="accordion-body faq_accordion_body">
                      <p>With a passion for innovation, we introduce ARTIVE as an immersive experiences that blend
                        captivating visuals with engaging audio products to redefine the way people interact with
                        multimedia, making it more intuitive, enjoyable, and meaningful. Whether it's entertainment,
                        education or communication; ARTIVE is at the forefront of delivering cutting-edge experiences
                        that resonate with audiences by offering a unique combination of creativity and technology.</p>

                    </div>
                  </div>
                </div>
                <div class="accordion-item faq_item">
                  <h2 class="accordion-header">
                    <button class="accordion-button collapsed faq_accordion" type="button"
                            data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseTwo"
                            aria-expanded="false" aria-controls="panelsStayOpen-collapseTwo">
                      What products do you offer?
                    </button>
                  </h2>
                  <div id="panelsStayOpen-collapseTwo" class="accordion-collapse collapse">
                    <div class="accordion-body faq_accordion_body">
                      <p>The interdisciplinary team does a full assessment of every patient
                        and
                        establishes a comprehensive list of medical issues and challenges.
                        The
                        rehabilitation team then decides on the correct intensity of
                        intervention for
                        the best possible outcome.The rehabilitation programme in the unit
                        includes, but
                        is not limited to, the following:</p>
                    </div>
                  </div>
                </div>
                <div class="accordion-item faq_item">
                  <h2 class="accordion-header">
                    <button class="accordion-button collapsed faq_accordion" type="button"
                            data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseThree"
                            aria-expanded="false" aria-controls="panelsStayOpen-collapseThree">
                      What services do you provide?
                    </button>
                  </h2>
                  <div id="panelsStayOpen-collapseThree" class="accordion-collapse collapse">
                    <div class="accordion-body faq_accordion_body">
                      <p>The interdisciplinary team does a full assessment of every patient
                        and
                        establishes a comprehensive list of medical issues and challenges.
                        The
                        rehabilitation team then decides on the correct intensity of
                        intervention for
                        the best possible outcome.The rehabilitation programme in the unit
                        includes, but
                        is not limited to, the following:</p>

                    </div>
                  </div>
                </div>
                <div class="accordion-item faq_item">
                  <h2 class="accordion-header">
                    <button class="accordion-button collapsed faq_accordion" type="button"
                            data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseFour"
                            aria-expanded="false" aria-controls="panelsStayOpen-collapseFour">
                      How can I contact Artive?
                    </button>
                  </h2>
                  <div id="panelsStayOpen-collapseFour" class="accordion-collapse collapse">
                    <div class="accordion-body faq_accordion_body">
                      <p>The interdisciplinary team does a full assessment of every patient
                        and
                        establishes a comprehensive list of medical issues and challenges.
                        The
                        rehabilitation team then decides on the correct intensity of
                        intervention for
                        the best possible outcome.The rehabilitation programme in the unit
                        includes, but
                        is not limited to, the following:</p>

                    </div>
                  </div>
                </div>
                <div class="accordion-item faq_item">
                  <h2 class="accordion-header">
                    <button class="accordion-button collapsed faq_accordion" type="button"
                            data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseFive"
                            aria-expanded="false" aria-controls="panelsStayOpen-collapseFive">
                      Are your products customizable?
                    </button>
                  </h2>
                  <div id="panelsStayOpen-collapseFive" class="accordion-collapse collapse">
                    <div class="accordion-body faq_accordion_body">
                      <p>The interdisciplinary team does a full assessment of every patient
                        and
                        establishes a comprehensive list of medical issues and challenges.
                        The
                        rehabilitation team then decides on the correct intensity of
                        intervention for
                        the best possible outcome.The rehabilitation programme in the unit
                        includes, but
                        is not limited to, the following:</p>

                    </div>
                  </div>
                </div>

                <div class="accordion-item faq_item">
                  <h2 class="accordion-header">
                    <button class="accordion-button collapsed faq_accordion" type="button"
                            data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseSix"
                            aria-expanded="false" aria-controls="panelsStayOpen-collapseSix">
                      Do you offer installation services?
                    </button>
                  </h2>
                  <div id="panelsStayOpen-collapseSix" class="accordion-collapse collapse">
                    <div class="accordion-body faq_accordion_body">
                      <p>The interdisciplinary team does a full assessment of every patient
                        and
                        establishes a comprehensive list of medical issues and challenges.
                        The
                        rehabilitation team then decides on the correct intensity of
                        intervention for
                        the best possible outcome.The rehabilitation programme in the unit
                        includes, but
                        is not limited to, the following:</p>

                    </div>
                  </div>
                </div>
                <div class="accordion-item faq_item">
                  <h2 class="accordion-header">
                    <button class="accordion-button collapsed faq_accordion" type="button"
                            data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseSeven"
                            aria-expanded="false" aria-controls="panelsStayOpen-collapseSeven">
                      Can I get a demonstration of your products?
                    </button>
                  </h2>
                  <div id="panelsStayOpen-collapseSeven" class="accordion-collapse collapse">
                    <div class="accordion-body faq_accordion_body">
                      <p>The interdisciplinary team does a full assessment of every patient
                        and
                        establishes a comprehensive list of medical issues and challenges.
                        The
                        rehabilitation team then decides on the correct intensity of
                        intervention for
                        the best possible outcome.The rehabilitation programme in the unit
                        includes, but
                        is not limited to, the following:</p>

                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>

        </div>
      </div>
    </div>


  </div>
</template>

<script>
import {useReCaptcha} from 'vue-recaptcha-v3';
import {reactive} from 'vue';

export default {
  name: "ContactUs",
  props: ['site'],

  setup(props) {
    const {executeRecaptcha} = useReCaptcha();
    const formData = reactive({
      first_name: '',
      email: '',
      phone: '',
      address: '',
      types: 'Solution',
      description: '',
    });

    const siteData = JSON.parse(props.site);

    const submitForm = async () => {
      try {
        // Get reCAPTCHA token
        const recaptchaToken = await executeRecaptcha('contact_form');
        const csrfToken = document.querySelector('[name=csrfmiddlewaretoken]').value;

        // Include token in form data
        const dataToSend = {
          ...formData,
          recaptchaToken,
        };

        // Submit the form
        const response = await fetch('/submit_contact_form/', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'X-CSRFToken': csrfToken
          },
          body: new URLSearchParams(dataToSend).toString(),
        });

        const data = await response.json();

        if (data.success) {
          alert(data.message);
          Object.assign(formData, {
            first_name: '',
            email: '',
            phone: '',
            address: '',
            types: 'Solution',
            description: '',
          });
        } else {
          alert(data.message);
        }
      } catch (error) {
        console.error('reCAPTCHA error:', error);
      }
    };

    return {formData, siteData, submitForm};
  }
};

</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

a {
  text-decoration: none;
}

.carousel-inner {
  height: 810px;
}

.about-top-head {
  color: #000;
  font-size: 48px;
  font-style: normal;
  font-weight: 600;
  line-height: 130%;
  /* 62.4px */
  text-align: start;
}


.carousel_caption_one {
  position: absolute;
  right: 6%;
  top: 25%;
  left: 5%;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  color: #fff;
  text-align: center;
  height: fit-content;
}

.about-mid {
  border-top: 10px solid #1AE5FE;
}

.about-bottom {
  border-top: 10px solid #1AFE5E;
}

.video_box {

  height: 350px;
  border-radius: 20px;
  background: #00B9D0;
}

.gradient {
  width: 100%;
  height: 100%;
  background: linear-gradient(99deg, rgba(30, 30, 30, 0.50) 28.34%, rgba(50, 50, 50, 0.00) 100%);
  position: absolute;
  top: 0;
  left: 0;
}

.contact_mid {
  padding: 80px;
  background: #FAFAFA;

}


.contact_card_head p {
  color: #1E1E1E;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  /* 171.429% */
}


.contact_location h3 {
  color: #1E1E1E;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 28px;
  /* 175% */
  letter-spacing: 0.8px;
}

.contact_location p {
  color: #1E1E1E;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  /* 175% */
  letter-spacing: 0.8px;
}

.contact_details {
  margin-bottom: 40px;
}

.contact_number_email h5 {
  color: #1E1E1E;
  font-size: 16px;
  font-style: normal;
  line-height: normal;
}

.map {
  width: 100%;
  height: 230px;
  padding: 10px;
  border-radius: 20px;
  margin-top: 20px;
}

.form {
  border-radius: 16px;
  border: 1px solid #1E1E1E;
  background: #FFF;
}

.form_field {
  display: flex;
  flex-direction: column;
  gap: 30px !important;
}

.contact_here input {
  color: #4A4A4A;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  /* 100% */
  letter-spacing: 0.48px;
  padding: 20px 30px;
  width: 100%;
  border-radius: 4px;
  border: 1px solid rgba(19, 33, 68, 0.10);
  background: #FFF;
  box-shadow: none;
  outline: none;
}

.form-check {
  padding: 20px 30px;
  border-radius: 4px;
  border: 1px solid rgba(19, 33, 68, 0.10);
  background: #FFF;
  box-shadow: 0px 0px 12px 0px rgba(204, 204, 204, 0.20);
}

.contact_here textarea {
  border-radius: 4px;
  border: 1px solid rgba(19, 33, 68, 0.20);
  background: #FFF;
  box-shadow: 0px 0px 12px 0px rgba(204, 204, 204, 0.20);
  width: 100%;
  height: 150px;
  color: #4A4A4A;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  /* 100% */
  letter-spacing: 0.48px;
  padding: 20px;
  outline: none;
}

.contact_sub {
  width: fit-content;
  margin-left: auto;
  margin-top: 10px;
  color: #FFF;
  text-align: center;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 32px;
  border-radius: 6px;
  background: linear-gradient(72deg, #1AE5FE 23.98%, #00B9D0 128.07%);
  box-shadow: 0px 6px 12px 0px rgba(201, 203, 208, 0.25);
  padding: 15px 48px;
  border: none;
}

.contact_mid_head {
  text-align: center;
  margin-bottom: 40px;
}

.contact_mid_head h3 {
  color: #1E1E1E;
  text-align: center;
  font-size: 48px;
  font-style: normal;
  font-weight: 350;
  line-height: 48px;
  letter-spacing: 0.5px;
  margin-bottom: 20px;
}

.contact_mid_head p {
  color: #1E1E1E;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  /* 200% */
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}


.faq_container {
  margin: 0 100px;
}

.faq_accordion {
  border: none !important;
  background: transparent !important;
  outline: none !important;
  box-shadow: none !important;
  color: #1E1E1E;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px;
  /* 116.667% */
}

.faq_item {
  border: none;
}

.faq_accordion_body {
  max-width: 1000px;
}

.faq_accordion_body p,
.faq_accordion_body ul li {
  color: #1E1E1E;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 30px;
  /* 187.5% */
}

.faq_header {
  color: #1E1E1E;
  text-align: center;
  margin-bottom: 40px;
  font-size: 48px;
  font-style: normal;
  font-weight: 350;
  line-height: 124%;
  /* 59.52px */
  text-transform: capitalize;
}

.faq_container {
  margin: 0;
}

.faq_item {
  background: transparent;
}

@media only screen and (max-width: 768px) {
  .contact_mid {
    padding: 1.25rem !important;
  }

  .carousel-inner {
    height: 600px;
  }

  .carousel_caption_one {
    position: absolute;
    right: 6%;
    top: 25%;
    left: 3%;
  }

  .about-top-head {
    font-size: 24px !important;
  }
}

@media only screen and (max-width: 991px) {
  .form {
    padding: 1.25rem !important;
  }

  .contact_mid {
    padding: 2.5rem;
  }

  .contact_sub {
    width: 100%;
    margin-left: 0;
  }

  .social_icon {
    justify-content: center;
  }

  .form_field {
    margin-top: 2.5rem;
  }

  .contact_mid_head h3, .about-top-head {
    font-size: 1.75rem;
  }

  .radios {
    flex-direction: column;
    width: 100%;
  }

  .carousel_caption_one {
    position: absolute;
    right: 6%;
    top: 25%;
    left: 3%;
  }
}

@media only screen and (max-width: 991px) {
}

@media only screen and (min-width: 992px) and (max-width: 1200px) {
  .carousel_caption_one {
    position: absolute;
    right: 6%;
    top: 25%;
    left: 2%;
  }
}
</style>